module.exports = __webpack_public_path__ + "img/37096-023.3892359f.jpg";